/* This is the EMIS Record keeping teaching time for secondary school components */
<template>
	<v-container>
		<div>
			<span v-html="title"></span>
		</div>
		<div>
			<table style="height: 72px;" border="1px;" width="850" cellspacing="0px;">
				<tbody>
					<tr>
						<td style="width: 250px; height: 50px; text-align: center; vertical-align: middle;" rowspan="2">បុគ្គលិកបង្រៀន</td>
						<td class="row-header" colspan="2">&le; ១៤ ម៉ោង</td>
						<td class="row-header" colspan="2">១៥ ម៉ោង</td>
						<td class="row-header" colspan="2">១៦ ម៉ោង</td>
						<td class="row-header" colspan="2">១៧ ម៉ោង</td>
						<td class="row-header" colspan="2">&ge; ១៨ ម៉ោង</td>
						<td class="row-header" colspan="2">សរុប</td>
					</tr>
					<tr>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
						<td class="row-data">សរុប</td>
						<td class="row-data">ស្រី</td>
					</tr>
					<tr v-for="(value, row) in c4.length" :key="row">
						<!-- Input columns -->
						<td class="row-title">{{c4[row]}}</td>
						<td v-for="(value, col) in data[row].dt.length" :key="col" class="row-data">
							<numberinput v-model="data[row].dt[col]" class="number"/>
						</td>
						<!-- Total columns -->
						<td class="row-data">
							<strong>{{row1[row] | blank}}</strong>
						</td>
						<td class="row-data">
							<strong>{{row2[row] | blank}}</strong>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</v-container>
</template>

<script>
import NumberInput from '@/components/common/NumberInput.vue'
import { c4 } from '@/utils/ascf/secConfig.js'
export default {
	props: ["data", "title"],
	components: {
    'numberinput': NumberInput
  },
	data() {
    return {
			c4: c4
    }
	},
	computed: {
    row1: function () {
			let result
			let d = this.data

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if(i % 2 === 0) {
						r[ind] = (r[ind] || 0) + Number(b)
					}
				})
				return r
			}, [])
			return result
    },
    row2: function () {
      let result
			let d = this.data

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if(i % 2 === 1) {
						r[ind] = (r[ind] || 0) + Number(b)
					}
				})
				return r
			}, [])
			return result
    }
	},
	filters: {
		blank: function (value) {
			if (value==0) return ''
			return value
		}
	}
}
</script>

<style scoped>
  .number {
      width:50px;
      text-align: center;
  }
  .row-data {
    width: 50px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
	.row-title {
    width: 250px;
    height: 25px;
    text-align:left;
    vertical-align: middle;
  }
  .row-header {
    width: 100px;
    height: 25px;
    text-align: center;
    vertical-align: middle;
  }
</style>